export default {
  title: {
    en: 'THANK YOU <br /> YOUR CARD HAS BEEN UPDATED SUCCESSFULLY',
  },
  payPalTitle: {
    en: 'THANK YOU <br /> YOU HAVE BEEN UPDATED TO PAYPAL SUCCESSFULLY',
  },
  text: {
    en: 'Our birdie is ready to deliver your <br /> Scentbird in {month}.',
  },
  button: {
    en: 'Go to site',
  },
  redirect: {
    en: 'You will be redirected in {timeLeft} seconds...',
  },
}
